export default __webpack_public_path__ + "static/media/banner1.bc597061.jpg";